
import { Record } from "../fable_modules/fable-library-js.5.3.0/Types.js";
import { record_type, option_type, string_type, bool_type, lambda_type, unit_type } from "../fable_modules/fable-library-js.5.3.0/Reflection.js";
import { HtmlHelper_createElement } from "../fable_modules/Feliz.3.3.3/Html.fs.js";
import { height_h1, cursor_cursorPointer, fontWeight_fontMedium, flexDirection_flexCol, animation_animateSpin, fontSize_textSm, padding_py4, gap_gap$002D2, justifyContent_justifyCenter, alignItems_itemsCenter, display_flex, tw } from "../fable_modules/Feliz.Tailwind.4.0.2/Strings.fs.js";
import { textColor_textPrimary700, hover, textColor_textPrimary600, textColor_textDanger600, textColor_textNeutral500 } from "./TailwindExtensions.js";
import { singleton, ofArray } from "../fable_modules/fable-library-js.5.3.0/List.js";
import { useEffect, useRef, createElement } from "react";
import React from "react";
import { IconWeight, IconSize, IconName, icon } from "./Icons.js";
import { join } from "../fable_modules/fable-library-js.5.3.0/String.js";
import { item } from "../fable_modules/fable-library-js.5.3.0/Array.js";
import { disposeSafe } from "../fable_modules/fable-library-js.5.3.0/Util.js";
import { defaultArg } from "../fable_modules/fable-library-js.5.3.0/Option.js";

/**
 * Props for the InfiniteScrollSentinel component
 */
export class Props extends Record {
    constructor(OnIntersect, IsLoading, HasError, ErrorMessage, OnRetry) {
        super();
        this.OnIntersect = OnIntersect;
        this.IsLoading = IsLoading;
        this.HasError = HasError;
        this.ErrorMessage = ErrorMessage;
        this.OnRetry = OnRetry;
    }
}

export function Props_$reflection() {
    return record_type("Shared.InfiniteScrollSentinel.Props", [], Props, () => [["OnIntersect", lambda_type(unit_type, unit_type)], ["IsLoading", bool_type], ["HasError", bool_type], ["ErrorMessage", option_type(string_type)], ["OnRetry", lambda_type(unit_type, unit_type)]]);
}

export const loadingIndicator = HtmlHelper_createElement("div", ofArray([["className", tw(ofArray([display_flex, alignItems_itemsCenter, justifyContent_justifyCenter, gap_gap$002D2, padding_py4, textColor_textNeutral500, fontSize_textSm]))], ["children", [HtmlHelper_createElement("span", ofArray([["className", tw(singleton(animation_animateSpin))], ["children", [createElement(icon, {
    name: new IconName(54, []),
    size: new IconSize(0, []),
    weight: new IconWeight(0, []),
})]]])), HtmlHelper_createElement("span", singleton(["children", singleton("Loading more...")]))]]]));

export function errorIndicator(message, onRetry) {
    return HtmlHelper_createElement("div", ofArray([["role", join(" ", ["alert"])], ["className", tw(ofArray([display_flex, flexDirection_flexCol, alignItems_itemsCenter, gap_gap$002D2, padding_py4]))], ["children", [HtmlHelper_createElement("p", ofArray([["className", tw(ofArray([fontSize_textSm, textColor_textDanger600]))], ["children", singleton(message)]])), HtmlHelper_createElement("button", ofArray([["className", tw(ofArray([fontSize_textSm, fontWeight_fontMedium, textColor_textPrimary600, hover(textColor_textPrimary700), cursor_cursorPointer]))], ["children", singleton("Try again")], ["onClick", (_arg) => {
        onRetry();
    }]]))]]]));
}

export const sentinelPlaceholder = HtmlHelper_createElement("div", ofArray([["className", tw(singleton(height_h1))], ["aria-hidden", "true"]]));

function SentinelObserver($props) {
    const onIntersect = $props.onIntersect;
    const sentinelRef = useRef(undefined);
    const dependencies = [onIntersect];
    useEffect(() => {
        const setup = (() => {
        let disp;
        const matchValue = sentinelRef.current;
        if (matchValue == null) {
            disp = {
                Dispose() {
                },
            };
        }
        else {
            const el = matchValue;
            const options = {
                threshold: 0.1,
            };
            const observer = new IntersectionObserver(((entries, _arg) => {
                for (let idx = 0; idx <= (entries.length - 1); idx++) {
                    const entry = item(idx, entries);
                    if (entry.isIntersecting) {
                        onIntersect();
                    }
                }
            }), options);
            observer.observe(el);
            disp = {
                Dispose() {
                    observer.disconnect();
                },
            };
        }
        return () => {
            let copyOfStruct = disp;
            disposeSafe(copyOfStruct);
        };
    })();
        return setup;
        }, dependencies);;
    return HtmlHelper_createElement("div", ofArray([["ref", sentinelRef], ["className", tw(singleton(height_h1))], ["aria-hidden", "true"]]));
}

/**
 * Renders the appropriate state: loading spinner, error with retry, or sentinel div.
 * On the client, the idle sentinel uses IntersectionObserver to trigger OnIntersect.
 */
export function view(props) {
    if (props.IsLoading) {
        return loadingIndicator;
    }
    else if (props.HasError) {
        return errorIndicator(defaultArg(props.ErrorMessage, "Couldn\'t load more pledges."), props.OnRetry);
    }
    else {
        return createElement(SentinelObserver, {
            onIntersect: props.OnIntersect,
        });
    }
}

//# sourceMappingURL=InfiniteScrollSentinel.js.map
